<template>
    <div>
    	<facebook class="m-1" :url="url" :scale="scale"></facebook>
	    <twitter class="m-1" :url="url" :title="title" :scale="scale"></twitter>
	    <telegram class="m-1" :url="url" :scale="scale"></telegram>
	    <whats-app class="m-1" :url="url" :title="title" :scale="scale"></whats-app>
	    <email class="m-1" :url="url" :subject="subject" :scale="scale"></email>
    </div>
</template>

<script>
import {
    Facebook,
    Twitter,
    Telegram,
    WhatsApp,
    Email,
} from "vue-socialmedia-share";

export default {
    props: {
        'url': String,
        'scale': String,
        'subject': String,
        'body': String,
        'title': String
    },
    components: {
        Facebook,
        Twitter,
        Telegram,
        WhatsApp,
        Email,
    }
}
</script>
